<script setup lang="ts">
interface ExtraTitleStyle {
  [key: string]: string;
}

interface Content {
  extraTitleStyle?: ExtraTitleStyle
  extraBackClass?: string
  extraClass?: string
  title: string
}
const props = defineProps<Content>()
</script>

<template>
  <PageContentCenter v-if="props.title" class="text-[#272E3B]" :class="props.extraBackClass">
    <h2 :style="props.extraTitleStyle"
      class="text-32px text-center text-inherit font-600 ml:pt-0rem ml:pb-48px max-ml:top-0 max-ml:pb-0 max-ml:pt-5rem"
      :class="props.extraClass">
      {{ props.title }}
    </h2>
  </PageContentCenter>
</template>

<style lang="scss" scoped>
.page-title {
  position: relative;
}
</style>